/***********************
 * ALERTS TABLE INFO
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  formatDateFull,
  timeFormatter,
  getAlarmColor,
  stringSorter,
  dateFormatter,
  numSorter,
} from "utils/general"

//Translation
import { withTranslation } from "react-i18next"
import TableReporting from "components/Tables/TableReporting"

const AlertsTable = props => {
  //Table data state
  const [series, setSeries] = useState([])
  const [origSeries, setOrigSeries] = useState([])
  //Filtered data
  const [filteredData, setFilteredData] = useState(series)
  const [handleValue, setHandleValue] = useState("")
  const [loading, setLoading] = useState(true)

  //Main title, excel and pdf name
  const title = props.t("Alerts")

  //Setting data state
  useEffect(() => {
    console.log("Data table alerts: ", props.data.list)
    if (props.data.list != filteredData) {
      // format alarmtype for search
      for (const element of props.data.list) {
        formatEntry(element)
      }
      setOrigSeries(props.data.list)
      setLoading(false)
    }
  }, [props.data.list])

  useEffect(() => {
    // console.log("entries filtered", series)
    if (series != undefined) {
      setFilteredData(series)
      if (handleValue != "") {
        handlingInput(handleValue)
      }
    }
  }, [series])

  // Table structure
  const columns = [
    {
      dataIndex: "date",
      title: props.t("Time"),
      render: value => dateFormatter(value),
      ellipsis: true,
      sorter: (a, b) => numSorter(a.date, b.date),
      width: "170px",
    },
    {
      dataIndex: "group",
      title: props.t("Group"),
      ellipsis: true,
      sorter: (a, b) => {
        return stringSorter(a, b, "group")
      },
      width: "180px",
    },
    {
      dataIndex: "client_name",
      title: props.t("Customer"),
      ellipsis: true,
      sorter: (a, b) => {
        return stringSorter(a, b, "client_name")
      },
      width: "220px",
    },
    {
      dataIndex: "alarm_type",
      title: props.t("Alarm type"),
      sorter: (a, b) => {
        return stringSorter(a, b, "alarm_type")
      },
      // Render can not be in function for its passing an array (otherwise its an object)
      render: (value, row) => (
        <span>
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: getAlarmColor(row.alarm_id),
              marginRight: 8,
            }}
          ></span>
          {value}
        </span>
      ),
      ellipsis: true,
      width: "250px",
    },
    {
      dataIndex: "acked_by",
      title: props.t("Handler"),
      ellipsis: true,
      sorter: (a, b) => {
        return stringSorter(a, b, "acked_by")
      },
      width: "200px",
    },
    {
      dataIndex: "closed_by",
      title: props.t("Closed by"),
      ellipsis: true,
      width: "200px",
    },
    {
      dataIndex: "ack_time",
      title: props.t("Handling time"),
      render: value => timeFormatter(value),
      ellipsis: true,
      width: "170px",
    },
    {
      dataIndex: "close_time",
      title: props.t("Closing time"),
      render: value => timeFormatter(value),
      ellipsis: true,
      width: "170px",
    },
  ]

  // Export values
  const pdfDate = true
  const pdfHeading = [
    props.t("Time"),
    props.t("Group"),
    props.t("Name"),
    props.t("Alarm type"),
    props.t("Handler"),
    props.t("Closed by"),
    props.t("Handling time"),
    props.t("Closing time"),
  ]
  const pdfData = filteredData.map(elt => [
    formatDateFull(elt.date),
    elt.group,
    elt.client_name,
    elt.alarm_type,
    elt.acked_by,
    elt.closed_by,
    timeFormatter(elt.ack_time),
    timeFormatter(elt.close_time),
  ])

  const xlsxHeading = [pdfHeading]

  const xlsxData = filteredData.map(elt => [
    formatDateFull(elt.date),
    elt.group,
    elt.client_name,
    elt.alarm_type,
    elt.acked_by,
    elt.closed_by,
    timeFormatter(elt.ack_time),
    timeFormatter(elt.close_time),
  ])

  const formatEntry = entry => {
    if (typeof entry.alarm_type === "string") {
      return entry
    } else {
      entry.alarm_type = props.t("AlarmTitles." + entry.alarm_type)
      return entry
    }
  }

  const handlingInput = value => {
    let result = []
    result = series.filter(
      data =>
        data.client_name?.toLowerCase().includes(value) ||
        data.acked_by?.toLowerCase().includes(value) ||
        data.group?.toLowerCase().includes(value) ||
        data.alarm_type?.toLowerCase().includes(value)
    )

    setFilteredData(result)

    // Set original data result if value ""
    if (value == "") {
      setFilteredData(series)
    }
  }

  // Handle search function
  const handleSearch = event => {
    let value = event.target.value.toLowerCase()
    setHandleValue(value)
    handlingInput(value)
  }

  return (
    <>
      <TableReporting
        filter={true}
        origSeries={origSeries}
        setSeries={setSeries}
        title={title}
        columns={columns}
        seriesFiltered={filteredData}
        xlsxHeading={xlsxHeading}
        xlsxData={xlsxData}
        pdfHeading={pdfHeading}
        pdfData={pdfData}
        pdfDate={pdfDate}
        handleSearch={handleSearch}
        loading={loading}
      ></TableReporting>
    </>
  )
}

AlertsTable.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
}

export default withTranslation()(AlertsTable)
